import { useMediaQuery } from "../../../hooks/useMediaQuery";

/**
 * Which panes the support workspace can show at the current viewport.
 *
 * The design's 1920 layout does not survive a laptop, so panes are dropped in
 * a fixed order as space runs out — context rail first, then the views rail,
 * then the list/ticket split:
 *
 * | Width      | Panes                                                     |
 * |------------|-----------------------------------------------------------|
 * | ≥1600      | views · list · ticket · context                            |
 * | 1280–1599  | views · list · ticket, context on demand                   |
 * | 1024–1279  | list · ticket, views collapsed to a dropdown               |
 * | <1024      | one pane at a time (list, then ticket)                     |
 *
 * @returns {{ showViewsRail: boolean, showContextRail: boolean,
 *   contextOnDemand: boolean, stacked: boolean }}
 */
export function useSupportLayout() {
  const wide = useMediaQuery("(min-width: 1600px)");
  const medium = useMediaQuery("(min-width: 1280px)");
  const narrow = useMediaQuery("(min-width: 1024px)");

  return {
    // The full views rail; below 1024 it becomes a chip row, between 1024 and
    // 1279 a dropdown.
    showViewsRail: narrow,
    // Pinned open only on the widest layout.
    showContextRail: wide,
    // Available behind a toggle rather than pinned.
    contextOnDemand: medium && !wide,
    // One pane at a time — list, then ticket.
    stacked: !narrow,
  };
}

export default useSupportLayout;
